import React from 'react';
import { t } from "i18next";

const ErrorCodeValueTab = (props) => {

    const style = {
        main :{
            margin: "30px 34px",
            fontFamily: "Open Sans",
            fontStyle: "normal"
        },
        box:{
            marginBottom:"25px"
        },
        label:{
            color:"#494949",
            fontWeight:"600",
            fontSize:"16px",
            lineHeight:"24px",
            display:"flex",
            alignItems:"flex-end",
            paddingBottom:"10px"
        },
        content:{
            color:"#FAFAFA",
            fontSize:"14px",
            fontWeight:"400",
            lineHeight:"22px"
        }
    }
  return (
    <>
        <div style={style.main}>
            <div style={style.box}>
                <span style={style.label}>{t("error-code-list.reason")}</span>
                <span style={style.content}>{props.reasonOfError}</span>
            </div>
            <div style={style.box}>
                <span style={style.label}>{t("error-code-list.action")}</span>
                <span style={style.content}>{props.action}</span>
            </div>
            <div style={style.box}>
                <span style={style.label}>{t("error-code-list.corrective")}</span>
                <span style={style.content}>{props.correctiveAction}</span>
            </div>
        </div>
    </>
  )
}

export default ErrorCodeValueTab